import styled, { css } from 'styled-components';

import { colors, mixins, fonts } from '../../css';

export const StyledInfoContainer = styled.div`
  width: 100%;
  border: 1px solid;
  ${({ theme, editing }) => (editing ? `border-color: ${theme.highlightTheme}` : `border-color: ${theme.lightText}`)};
`;

export const ChildrenContainer = styled.div`
  width: 100%;
  background-color: ${colors.colorWhite};
  ${({ noPadding }) => ` padding: ${noPadding ? `0` : mixins.pxToRem(20)}`};
  display: flex;
  flex-direction: column;
`;

export const SubBar = styled.div`
  width: 100%;
  height: ${mixins.pxToRem(48)};
  background-color: ${colors.colorGrey05};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${mixins.pxToRem(20)};
`;

export const LeftSubBarContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  button {
    margin-right: ${mixins.pxToRem(10)};
  }
`;

export const RightSubBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  button {
    margin-left: ${mixins.pxToRem(10)};
  }
`;

const disabledLinkButton = css`
  background-color: ${colors.colorGrey04};
  color: ${colors.colorGrey03};
  &:hover {
    background-color: ${colors.colorGrey04};
    color: ${colors.colorGrey03};
    cursor: auto;
  }
`;

export const LinkButton = styled.a`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: ${mixins.pxToRem(5)};
  padding: ${mixins.pxToRem(5)} ${mixins.pxToRem(20)};
  min-height: ${mixins.pxToRem(30)};
  border-radius: ${mixins.pxToRem(5)};
  text-decoration: none;
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(12)};
  letter-spacing: 1px;
  text-transform: uppercase;
  ${({ theme }) => `color: ${theme.lightText}`};
  ${({ theme }) => `background-color: ${theme.highlightTheme}`};
  &:hover {
    ${({ theme }) => `background-color: ${theme.midTheme}`};
  }
  ${({ disabled }) => disabled && disabledLinkButton};
`;
